export const COOKIE_LOGIN_REDIRECT = 'login-redirect'
export const COOKIE_AUTH_TOKEN = 'token'
export const COOKIE_EMPLOYEE = 'employee'

export const EVENT_CALENDER_MEMBER_ONLY_TAG = 'membersOnly'

export const DEFAULT_LIST_SIZE = 18
